import React, { FC, Fragment, ReactElement } from 'react';

import { FloatingArrow, FloatingPortal, Placement } from '@floating-ui/react';
import { useFloatingTooltip } from './useFloatingTooltip';

export interface IProps {
  placement?: Placement;
  children: ReactElement<any>[];
  showArrow?: boolean;
  arrowClassName?: string;
  enabled?: boolean;
}

const FloatingTooltip: FC<IProps> = (props) => {
  const {
    placement = 'top',
    showArrow = false,
    enabled = true,
    arrowClassName,
    children,
  } = props;

  if (children.length !== 2) {
    console.warn(
      '<FloatingTooltip /> requires exactly two children. The first child is the reference element and the second child is the floating element.'
    );
    return <Fragment />;
  }

  const tooltip = useFloatingTooltip({
    enabled,
    placement,
    showArrow,
  });

  const [ReferenceNode, FloatingNode] = children;

  return (
    <>
      <ReferenceNode.type
        {...tooltip.getReferenceProps(ReferenceNode.props)}
        ref={tooltip.refs.setReference}
      />

      {tooltip.isOpen && (
        <FloatingPortal>
          <FloatingNode.type
            style={tooltip.floatingStyles}
            {...tooltip.getFloatingProps(FloatingNode.props)}
            ref={tooltip.refs.setFloating}
          >
            {FloatingNode.props.children}

            {showArrow && (
              <FloatingArrow
                ref={tooltip.arrowRef}
                context={tooltip.context}
                className={arrowClassName}
              />
            )}
          </FloatingNode.type>
        </FloatingPortal>
      )}
    </>
  );
};

export default FloatingTooltip;
